import { IRootState } from '../reducer.types';
import { ITheme } from './App.types';
import { IAppState } from './reducer.types';
import { COMPONENT_NAME as APP_NAMESPACE } from './constants';

export const getAppState = (state: IRootState): IAppState => {
  return state[APP_NAMESPACE];
};

export const getTheme = (state: IRootState): ITheme => {
  return getAppState(state).theme;
};
